import type { DetalheSimulacaoDialogProps } from "./types-detalhe-simulacao-dialog";
import { useDetalheSimulacaoDialog } from "./use-detalhe-simulacao-dialog";
import { DetalheSimulacaoDialogView } from "./view-detalhe-simulacao-dialog";

/** Detalhe de uma simulação do histórico (HU 2221): resumo e cartões das alterações. */
export function DetalheSimulacaoDialog(props: DetalheSimulacaoDialogProps) {
  const vm = useDetalheSimulacaoDialog(props);

  return <DetalheSimulacaoDialogView {...vm} />;
}

export type * from "./types-detalhe-simulacao-dialog";
